import { render, staticRenderFns } from "./CompanyDepartmentDetailTable.vue?vue&type=template&id=4f92c439&scoped=true&"
import script from "./CompanyDepartmentDetailTable.vue?vue&type=script&lang=js&"
export * from "./CompanyDepartmentDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDepartmentDetailTable.vue?vue&type=style&index=0&id=4f92c439&lang=scss&scoped=true&"
import style1 from "./CompanyDepartmentDetailTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f92c439",
  null
  
)

export default component.exports